/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AssegnazioneArticoloCedolaAttivoPatchForm } from '../model/assegnazione-articolo-cedola-attivo-patch-form';
// @ts-ignore
import { AssegnazioneArticoloCedolaCreationForm } from '../model/assegnazione-articolo-cedola-creation-form';
// @ts-ignore
import { AssegnazioneArticoloCedolaDTO } from '../model/assegnazione-articolo-cedola-dto';
// @ts-ignore
import { AssegnazioneArticoloCedolaListFilter } from '../model/assegnazione-articolo-cedola-list-filter';
// @ts-ignore
import { AssegnazioneArticoloCedolaPatchForm } from '../model/assegnazione-articolo-cedola-patch-form';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelAssegnazioneArticoloCedolaDTO } from '../model/paged-model-assegnazione-articolo-cedola-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    AssegnazioneArticoloCedolaControllerServiceInterface,
    CreateAssegnazioneArticoloCedolaRequestParams,
    DeleteAssegnazioneArticoloCedolaRequestParams,
    GetAssegnazioneArticoloCedolaRequestParams,
    ListAssegnazioneArticoliCedolaRequestParams,
    SetAttivoAssegnazioneArticoloCedolaRequestParams,
    UpdateAssegnazioneArticoloCedolaRequestParams
} from './assegnazione-articolo-cedola-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class AssegnazioneArticoloCedolaControllerService extends BaseService implements AssegnazioneArticoloCedolaControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Crea un nuovo articolo cedola sotto l\&#39;Assegnazione (rifiutato se Assegnazione.contributo IS NOT NULL — vincolo XOR)
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}/articoli-cedole
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createAssegnazioneArticoloCedola(requestParameters: CreateAssegnazioneArticoloCedolaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AssegnazioneArticoloCedolaDTO>;
    public createAssegnazioneArticoloCedola(requestParameters: CreateAssegnazioneArticoloCedolaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AssegnazioneArticoloCedolaDTO>>;
    public createAssegnazioneArticoloCedola(requestParameters: CreateAssegnazioneArticoloCedolaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AssegnazioneArticoloCedolaDTO>>;
    public createAssegnazioneArticoloCedola(requestParameters: CreateAssegnazioneArticoloCedolaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling createAssegnazioneArticoloCedola.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling createAssegnazioneArticoloCedola.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling createAssegnazioneArticoloCedola.');
        }
        const idAssegnazione = requestParameters?.idAssegnazione;
        if (idAssegnazione === null || idAssegnazione === undefined) {
            throw new Error('Required parameter idAssegnazione was null or undefined when calling createAssegnazioneArticoloCedola.');
        }
        const assegnazioneArticoloCedolaCreationForm = requestParameters?.assegnazioneArticoloCedolaCreationForm;
        if (assegnazioneArticoloCedolaCreationForm === null || assegnazioneArticoloCedolaCreationForm === undefined) {
            throw new Error('Required parameter assegnazioneArticoloCedolaCreationForm was null or undefined when calling createAssegnazioneArticoloCedola.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assegnazioni/${this.configuration.encodeParam({name: "idAssegnazione", value: idAssegnazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/articoli-cedole`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AssegnazioneArticoloCedolaDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: assegnazioneArticoloCedolaCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Soft-delete di un articolo cedola (flip attivo&#x3D;false). La riga resta in DB; per eliminarla fisicamente, DELETE sull\&#39;Assegnazione parent (cascade hard).
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}/articoli-cedole/{idArticolo}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteAssegnazioneArticoloCedola(requestParameters: DeleteAssegnazioneArticoloCedolaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteAssegnazioneArticoloCedola(requestParameters: DeleteAssegnazioneArticoloCedolaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteAssegnazioneArticoloCedola(requestParameters: DeleteAssegnazioneArticoloCedolaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteAssegnazioneArticoloCedola(requestParameters: DeleteAssegnazioneArticoloCedolaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling deleteAssegnazioneArticoloCedola.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling deleteAssegnazioneArticoloCedola.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling deleteAssegnazioneArticoloCedola.');
        }
        const idAssegnazione = requestParameters?.idAssegnazione;
        if (idAssegnazione === null || idAssegnazione === undefined) {
            throw new Error('Required parameter idAssegnazione was null or undefined when calling deleteAssegnazioneArticoloCedola.');
        }
        const idArticolo = requestParameters?.idArticolo;
        if (idArticolo === null || idArticolo === undefined) {
            throw new Error('Required parameter idArticolo was null or undefined when calling deleteAssegnazioneArticoloCedola.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assegnazioni/${this.configuration.encodeParam({name: "idAssegnazione", value: idAssegnazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/articoli-cedole/${this.configuration.encodeParam({name: "idArticolo", value: idArticolo, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di un articolo cedola per id
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}/articoli-cedole/{idArticolo}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getAssegnazioneArticoloCedola(requestParameters: GetAssegnazioneArticoloCedolaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AssegnazioneArticoloCedolaDTO>;
    public getAssegnazioneArticoloCedola(requestParameters: GetAssegnazioneArticoloCedolaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AssegnazioneArticoloCedolaDTO>>;
    public getAssegnazioneArticoloCedola(requestParameters: GetAssegnazioneArticoloCedolaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AssegnazioneArticoloCedolaDTO>>;
    public getAssegnazioneArticoloCedola(requestParameters: GetAssegnazioneArticoloCedolaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getAssegnazioneArticoloCedola.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling getAssegnazioneArticoloCedola.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling getAssegnazioneArticoloCedola.');
        }
        const idAssegnazione = requestParameters?.idAssegnazione;
        if (idAssegnazione === null || idAssegnazione === undefined) {
            throw new Error('Required parameter idAssegnazione was null or undefined when calling getAssegnazioneArticoloCedola.');
        }
        const idArticolo = requestParameters?.idArticolo;
        if (idArticolo === null || idArticolo === undefined) {
            throw new Error('Required parameter idArticolo was null or undefined when calling getAssegnazioneArticoloCedola.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assegnazioni/${this.configuration.encodeParam({name: "idAssegnazione", value: idAssegnazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/articoli-cedole/${this.configuration.encodeParam({name: "idArticolo", value: idArticolo, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AssegnazioneArticoloCedolaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata degli articoli cedola di un\&#39;Assegnazione (filtri: area containsCi, editore eq, attivo bool default&#x3D;true, q containsCi titolo+editore+note). Default sort: area ASC, titolo ASC. Default strict su attivo: senza ?attivo&#x3D; ritorna solo attivo&#x3D;true
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}/articoli-cedole
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listAssegnazioneArticoliCedola(requestParameters: ListAssegnazioneArticoliCedolaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelAssegnazioneArticoloCedolaDTO>;
    public listAssegnazioneArticoliCedola(requestParameters: ListAssegnazioneArticoliCedolaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelAssegnazioneArticoloCedolaDTO>>;
    public listAssegnazioneArticoliCedola(requestParameters: ListAssegnazioneArticoliCedolaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelAssegnazioneArticoloCedolaDTO>>;
    public listAssegnazioneArticoliCedola(requestParameters: ListAssegnazioneArticoliCedolaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listAssegnazioneArticoliCedola.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling listAssegnazioneArticoliCedola.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling listAssegnazioneArticoliCedola.');
        }
        const idAssegnazione = requestParameters?.idAssegnazione;
        if (idAssegnazione === null || idAssegnazione === undefined) {
            throw new Error('Required parameter idAssegnazione was null or undefined when calling listAssegnazioneArticoliCedola.');
        }
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listAssegnazioneArticoliCedola.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listAssegnazioneArticoliCedola.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assegnazioni/${this.configuration.encodeParam({name: "idAssegnazione", value: idAssegnazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/articoli-cedole`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelAssegnazioneArticoloCedolaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Toggle attivo di un articolo cedola (riattivazione o disattivazione esplicita). Riattivazione (attivo&#x3D;true) rifiutata se Assegnazione.contributo IS NOT NULL (XOR).
     * @endpoint patch /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}/articoli-cedole/{idArticolo}/attivo
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public setAttivoAssegnazioneArticoloCedola(requestParameters: SetAttivoAssegnazioneArticoloCedolaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AssegnazioneArticoloCedolaDTO>;
    public setAttivoAssegnazioneArticoloCedola(requestParameters: SetAttivoAssegnazioneArticoloCedolaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AssegnazioneArticoloCedolaDTO>>;
    public setAttivoAssegnazioneArticoloCedola(requestParameters: SetAttivoAssegnazioneArticoloCedolaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AssegnazioneArticoloCedolaDTO>>;
    public setAttivoAssegnazioneArticoloCedola(requestParameters: SetAttivoAssegnazioneArticoloCedolaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling setAttivoAssegnazioneArticoloCedola.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling setAttivoAssegnazioneArticoloCedola.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling setAttivoAssegnazioneArticoloCedola.');
        }
        const idAssegnazione = requestParameters?.idAssegnazione;
        if (idAssegnazione === null || idAssegnazione === undefined) {
            throw new Error('Required parameter idAssegnazione was null or undefined when calling setAttivoAssegnazioneArticoloCedola.');
        }
        const idArticolo = requestParameters?.idArticolo;
        if (idArticolo === null || idArticolo === undefined) {
            throw new Error('Required parameter idArticolo was null or undefined when calling setAttivoAssegnazioneArticoloCedola.');
        }
        const assegnazioneArticoloCedolaAttivoPatchForm = requestParameters?.assegnazioneArticoloCedolaAttivoPatchForm;
        if (assegnazioneArticoloCedolaAttivoPatchForm === null || assegnazioneArticoloCedolaAttivoPatchForm === undefined) {
            throw new Error('Required parameter assegnazioneArticoloCedolaAttivoPatchForm was null or undefined when calling setAttivoAssegnazioneArticoloCedola.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assegnazioni/${this.configuration.encodeParam({name: "idAssegnazione", value: idAssegnazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/articoli-cedole/${this.configuration.encodeParam({name: "idArticolo", value: idArticolo, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/attivo`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AssegnazioneArticoloCedolaDTO>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: assegnazioneArticoloCedolaAttivoPatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replace di un articolo cedola (richiede version per optimistic lock). Operativo solo su articoli attivi&#x3D;true: per riattivare un articolo soft-deleted usare PATCH /attivo. Rifiutato se Assegnazione.contributo IS NOT NULL (XOR).
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}/articoli-cedole/{idArticolo}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateAssegnazioneArticoloCedola(requestParameters: UpdateAssegnazioneArticoloCedolaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AssegnazioneArticoloCedolaDTO>;
    public updateAssegnazioneArticoloCedola(requestParameters: UpdateAssegnazioneArticoloCedolaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AssegnazioneArticoloCedolaDTO>>;
    public updateAssegnazioneArticoloCedola(requestParameters: UpdateAssegnazioneArticoloCedolaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AssegnazioneArticoloCedolaDTO>>;
    public updateAssegnazioneArticoloCedola(requestParameters: UpdateAssegnazioneArticoloCedolaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling updateAssegnazioneArticoloCedola.');
        }
        const idIstituto = requestParameters?.idIstituto;
        if (idIstituto === null || idIstituto === undefined) {
            throw new Error('Required parameter idIstituto was null or undefined when calling updateAssegnazioneArticoloCedola.');
        }
        const idPlesso = requestParameters?.idPlesso;
        if (idPlesso === null || idPlesso === undefined) {
            throw new Error('Required parameter idPlesso was null or undefined when calling updateAssegnazioneArticoloCedola.');
        }
        const idAssegnazione = requestParameters?.idAssegnazione;
        if (idAssegnazione === null || idAssegnazione === undefined) {
            throw new Error('Required parameter idAssegnazione was null or undefined when calling updateAssegnazioneArticoloCedola.');
        }
        const idArticolo = requestParameters?.idArticolo;
        if (idArticolo === null || idArticolo === undefined) {
            throw new Error('Required parameter idArticolo was null or undefined when calling updateAssegnazioneArticoloCedola.');
        }
        const assegnazioneArticoloCedolaPatchForm = requestParameters?.assegnazioneArticoloCedolaPatchForm;
        if (assegnazioneArticoloCedolaPatchForm === null || assegnazioneArticoloCedolaPatchForm === undefined) {
            throw new Error('Required parameter assegnazioneArticoloCedolaPatchForm was null or undefined when calling updateAssegnazioneArticoloCedola.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/istituti/${this.configuration.encodeParam({name: "idIstituto", value: idIstituto, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/plessi/${this.configuration.encodeParam({name: "idPlesso", value: idPlesso, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/assegnazioni/${this.configuration.encodeParam({name: "idAssegnazione", value: idAssegnazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/articoli-cedole/${this.configuration.encodeParam({name: "idArticolo", value: idArticolo, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AssegnazioneArticoloCedolaDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: assegnazioneArticoloCedolaPatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
